export default __webpack_public_path__ + "static/media/HN.471e8b63.svg";